<template>
    <div class="modal fade" :id="'popupMessageSetting' + targetDialog" tabindex="-1" role="dialog" aria-labelledby="modalPopupMessageSetting" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv">
                <div class="modal-header modal-header-scv-cmn" style="width: 100%">
                    <div class="modal-header-text-box-scv" style="width: 100%">
                        <span class="modal-header-text-scv">端末通知メッセージ設定</span>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div class="d-flex flex-column">
                        <div class="modal-body-text-area-scv">
                            <span>アラート発生時に端末に通知するメッセージを入力してください。</span>
                        </div>
                        <div style="height:12px;"></div>

                        <!-- メインカテゴリはAlertSettingItem.vueを利用したかったが、本コントロールとループになってしまい利用できなかった。-->
                        <!-- やむを得ず、カテゴリを自分で作成した。-->
                        <div class="alert-setting-item" style="padding: 0px 0px 0px 8px;">
                            <div class="alert-main-category">
                                <span class="main-category-font">{{alertSettingName}}：端末通知メッセージ</span>
                                <div style="width:40px"></div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column" style="min-height: 100%;">
                        <MaskInput convertType="text-sjis"
                                   :enableNewLine="true"
                                   class="input-text-scv"
                                   v-model="editPopupMessage"
                                   maxlength="64"
                                   style="width: 560px; min-height: 152px"
                                   :id="'textPopupMessage' + targetDialog">
                        </MaskInput>
                    </div>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" id="buttonApply" @click="onApplyButton" style="margin-right: 40px;">OK</button>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal">キャンセル</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Vue, Options } from "vue-class-component";
    import $ from "jquery";
    import MaskInput from '@/components/Input/MaskInput.vue';
    import { BootstrapUtil } from "lib-vue-v2/util";

    @Options({
        components: {
            MaskInput,
        },
        props: {
            alertSettingName: String,
            popupMessage: String,
            targetDialog: String,
        },
        emits: [
            'onApplyPopupMessageButton',
        ],
    })
    export default class AlertPopupMessageSetting extends Vue {

        private targetDialog!: string;
        private editPopupMessage = "";
        private popupMessage!: string;

        public mounted(): void {
            // 端末通知メッセージ画面を開いた際の処理
            const el = document.getElementById('popupMessageSetting' + this.targetDialog);
            if(null != el) {
                el.addEventListener('show.bs.modal', () => {
                    this.editPopupMessage = this.popupMessage;
                });

                // 端末通知メッセージ画面が表示された際の処理
                el.addEventListener('shown.bs.modal', async(e) => {
                    // 初期フォーカスを「表示項目名」に設定する
                    $('#textPopupMessage' + this.targetDialog).focus();
                });
            }
        }

        /**
            * 「適用」ボタン押下時イベント
            */
        public onApplyButton() {

            // #41235 【SKYSEAクラウドマルチテナント対応】アラート設定の通知内容に空白/改行を含むと設定と実際の通知に差異がある
            // ⇒ 左右の空白は不要なため、トリムを行う
            
            // 初回に何も入力しない場合、nullが渡る場合がありtrimでエラーになるため、nullチェックを追加
            if (this.editPopupMessage !== null && this.editPopupMessage !== undefined) {
            var sendPopupMessage = this.editPopupMessage.trim();

            if (0 == sendPopupMessage.length) {
                if (window.confirm("端末通知メッセージが未入力です。\r\nメッセージを以下の初期値に戻してもよろしいですか？\r\n\r\n「システム担当者にご連絡ください。」")) {
                    // 親に通知
                    this.$emit("onApplyPopupMessageButton", "");

                    // モーダルダイアログを閉じる。
                    BootstrapUtil.hideModal('popupMessageSetting' + this.targetDialog);
                }
            }
            else {
                // 親に通知
                this.$emit("onApplyPopupMessageButton", sendPopupMessage);

                // モーダルダイアログを閉じる。
                BootstrapUtil.hideModal('popupMessageSetting' + this.targetDialog);
                }
            }
            else {
                if (window.confirm("端末通知メッセージが未入力です。\r\nメッセージを以下の初期値に戻してもよろしいですか？\r\n\r\n「システム担当者にご連絡ください。」")) {
                    // 親に通知
                    this.$emit("onApplyPopupMessageButton", "");

                    // モーダルダイアログを閉じる。
                    BootstrapUtil.hideModal('popupMessageSetting' + this.targetDialog);
                }
            }
        }
    }
</script>

<style scoped>
    /*
       app.cssに定義することも考えましたが、ローカル定義にコピーしました。 
       通常はメインカテゴリの実装はAlertSettingItem.vueを利用してください。
     */
    /* メインカテゴリ */
    .alert-setting-item {
        border-bottom: 1px solid #BEE6FF;
        min-height: 45px; /* 44px + 1px(区切り線)*/
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
    }

    /* メインカテゴリのタイトル */
    .alert-main-category {
        display: flex;
        align-items: start;
        margin-top: 12px;
    }

    /* メインカテゴリ時のフォント */
    .main-category-font {
        font-size: 14px;
        color: #2582D7;
        font-weight: 700;
    }
</style>
